export default "__VITE_ASSET__DoxWE44x__"